// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__DxBZR","bigColWidth":"Table_bigColWidth__2Y5vQ","biggerColWidth":"Table_biggerColWidth__jKU8V","row":"Table_row__2Ev3p","col":"Table_col__3K-ki"};